import { copyExerciseLinkToClipboard } from '@/screens/exercises/exercise-utils';
import { Link } from '@mui/icons-material';
import { IconButton, Tooltip } from '@mui/material';

export const CopyExerciseLinkButton = (props: { exerciseId: string }) => {
  const { exerciseId } = props;
  return (
    <Tooltip title="Copy exercise link to clipboard">
      <IconButton
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          copyExerciseLinkToClipboard(exerciseId);
        }}
        sx={{ width: 30, fontSize: 10, mr: 'auto' }}
      >
        <Link />
      </IconButton>
    </Tooltip>
  );
};
